import api from './AxiosInstance';

export class AdherentsService {

  getAllAdherents = async () => {
    try {
      const response = await api.get(`/Adherent/list`, {

      });
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des données :', error);
      // Gérer l'erreur ici si nécessaire
      throw error;
    }
  };

  getAllDocAutorises = async (codeadht) => {

    try {
      const response = await api.get(`/Adherent/DocSocAutorises/list/${codeadht}`, {

      });
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des données :', error);
      // Gérer l'erreur ici si nécessaire
      throw error;
    }
  };


  getTauxpc = async (codeadht) => {
    try {
      const response = await api.get(`/TauxPC/IPM/list/${codeadht}`, {

      });
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des données :', error);
      // Gérer l'erreur ici si nécessaire
      throw error;
    }
  };

  getTauxpcAss = async (codeadht) => {
    try {
      const response = await api.get(`/TauxPC/ASS/list/${codeadht}`, {

      });
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des données :', error);
      // Gérer l'erreur ici si nécessaire
      throw error;
    }
  };

  addAdherents = async (newPrestation) => {
    try {


      const response = await api.post(`/Adherent/add`, newPrestation)

      return response.data;
    } catch (error) {
      console.error('Erreur lors de l\'ajout de prestation :', error);
      // Gérer l'erreur ici si nécessaire
      throw error;
    }
  };


  updateAdherents = async (updatedAdherent) => {
    try {


      const response = await api.put(`/Adherent/update`, updatedAdherent)

      return response.data;
    } catch (error) {
      console.error('Erreur lors de la mise à jour de adherent :', error);
      throw error;
    }
  };

  updateDocAutorisesPartAll = async (listDocuments) => {

    try {


      const response = await api.put(`/Adherent/updateDocAutorisePartAll`, listDocuments)

      return response.data;
    } catch (error) {
      console.error('Erreur lors de la mise à jour de adherent :', error);
      throw error;
    }
  };

  updateDocAutorisesPartOnly = async (listDocuments) => {

    try {


      const response = await api.put(`/Adherent/updateDocAutorisePartOnly`, listDocuments)

      return response.data;
    } catch (error) {
      console.error('Erreur lors de la mise à jour de adherent :', error);
      throw error;
    }
  };


  deleteAdherents = async (adherentId) => {
    try {

      const response = await api.delete(`/Adherent/delete/${adherentId}`)

      return response.data;
    } catch (error) {
      console.error('Erreur lors de la suppression de adherent :', error);
      throw error;
    }
  };
}


